export const RIGHTS_HINT_MESSAGE_TYPE = {
  PRODUCTION: 'PRODUCTION',
  SEASON: 'SEASON',
  SEASON_RELEASE: 'SEASON_RELEASE',
  CLEARANCE: 'CLEARANCE',
};
